// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.5 7C3.5 4.23858 5.73858 2 8.5 2C11.2614 2 13.5 4.23858 13.5 7C13.5 9.76142 11.2614 12 8.5 12C5.73858 12 3.5 9.76142 3.5 7ZM17.3787 6.46447L19.5 8.58579L21.6213 6.46447L23.0355 7.87868L20.9142 10L23.0355 12.1213L21.6213 13.5355L19.5 11.4142L17.3787 13.5355L15.9645 12.1213L18.0858 10L15.9645 7.87868L17.3787 6.46447ZM0 19C0 16.2386 2.23858 14 5 14H12C14.7614 14 17 16.2386 17 19V21C9.78733 21 3.91775 21 0 21V19Z"}}]};

const UserError1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-error-1-filled',
    ref,
    icon: element,
  },
));

UserError1FilledIcon.displayName = 'UserError1FilledIcon';

export default UserError1FilledIcon;
